export default __webpack_public_path__ + "57fe7c5ecbce7f0f3b8e7f9c0a29a987.png";